<template>
  <collapsible-section class='_pt0 _pb0' :collapsed='internalCollapsed'>
    <template #headerText>
      <p class='color-leaf'>Language Assistance</p>
    </template>
    <template #collapsibleSection>
      <async-loader v-if='memberDetailsLoading'/>
      <div v-else container>
        <div grid>
          <div column>
            <app-select
              :disabled='memberLocked'
              v-model='internalValue.writtenLanguage'
              :options="spokenWrittenlanguageOptions"
              valueKey='writtenLanguage'
              label='Written Language:'
              @input="emitInternalValue"
              />
          </div>
          <div column>
            <app-select
              :disabled='memberLocked'
              v-model='internalValue.spokenLanguage'
              :options="spokenWrittenlanguageOptions"
              valueKey='spokenLanguage'
              @input="emitInternalValue"
              label='Spoken Language:'/>
          </div>
          <div column>
            <app-select
              :disabled='memberLocked'
              v-model='internalValue.race'
              :options="raceOptions"
              valueKey='race'
              @input="emitInternalValue"
              label='Race:'/>
          </div>
          <div column>
            <app-select
              :disabled='memberLocked'
              v-model='internalValue.ethnicity'
              :options="ethnicityOptions"
              valueKey='ethnicity'
              @input="emitInternalValue"
              label='Ethnicity:'/>
          </div>
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import AppSelect from '@atoms/Select'
  import AsyncLoader from '@molecules/AsyncLoader'
  import CollapsibleSection from '@sections/CollapsibleSection'

  import SelectOptions from '@mixins/SelectOptions'
  import formattable from '@mixins/formattable'
  import ValueInputBindings from '@mixins/ValueInputBindings'
  import autoExpandable from '@mixins/autoExpandable'

  export default {
    mixins: [
      formattable,
      ValueInputBindings,
      SelectOptions,
      autoExpandable
    ],
    components: {
      CollapsibleSection,
      AppSelect,
      AsyncLoader
    },
    props: {
      collapsed: {
        type: Boolean,
        default: true
      },
      memberDetailsLoading: {
        type: Boolean,
        default: false
      },
      memberLocked: Boolean,
      value: {
        type: Object,
        default() {
          return {
            writtenLanguage: '',
            spokenLanguage: '',
            race: '',
            ethnicity: ''
          }
        }
      }
    }
  }
</script>
